import CameraImage from "./../../../assets/icons/no-camera 1.png";
import { useTranslation } from "react-i18next";

function CameraAccessDenied() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col m-auto items-center justify-center">
      {/* Tenant primary, not kolula's turquoise — same fix as NoResult. */}
      <div className="w-32 h-32 rounded-full bg-primary/10 
      flex items-center justify-center mb-6">
        {/* Decorative: the text below says what happened. */}
        <img
          src={CameraImage}
          alt=""
          aria-hidden="true"
          className="object-cover"
          style={{ width: "93px", height: "93px" }}
        />
      </div>
      <div className="text-black text-lg font-medium mb-2">
        {t("itemRetrieval.confirmLocation.camera.error")}
      </div>
      <div className="text-black text-lg font-normal">
        {t("itemRetrieval.confirmLocation.camera.error_info")}
      </div>
    </div>
  );
}

export default CameraAccessDenied;
